import { render } from 'react-dom';
import './index.css';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { LoadScript } from '@react-google-maps/api';
import jaLocale from 'date-fns/locale/ja';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Dimmer, Loader } from 'semantic-ui-react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { history, Store } from './redux/store';
import { ExtendedUtils } from './utilities/date-utils';
import { MapCollection } from './collection/map/map.collection';
import { Config } from './config/config';
import { Redirect } from './hooks/use-redirect';

render(
  <Provider store={Store}>
    <ConnectedRouter history={history}>
      <MuiPickersUtilsProvider utils={ExtendedUtils} locale={jaLocale}>
        <LoadScript
          googleMapsApiKey={Config.apiKey}
          loadingElement={(
            <>
              <Redirect />
              <Dimmer active style={{ zIndex: 10000000 }}>
                <Loader size="massive" inverted content="Loading" />
              </Dimmer>
            </>
          )}
        >
          <App />
        </LoadScript>
      </MuiPickersUtilsProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
